import React from 'react';
import { Card } from 'react-bootstrap';
import './FeatureCard.css'; // 自定义样式

const FeatureCard = ({ icon, title, description }) => {
  return (
    <Card className="feature-card">
      <Card.Body>
        <div className="card-icon">
          <img src={icon} alt={`${title} Icon`} />
        </div>
        <Card.Title>{title}</Card.Title>
        <Card.Text>{description}</Card.Text>
      </Card.Body>
    </Card>
  );
};

export default FeatureCard;
